import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UsersComponent } from './users/users.component';
import { DeleteRequestsComponent } from './delete-requests/delete-requests.component';
import { TestAnalyticsComponent } from './test-analytics/test-analytics.component';
import { DetailsAnswerSheetComponent } from './details-answer-sheet/details-answer-sheet.component';
import { SupportDetailsComponent } from './support-details/support-details.component';
import { JobApplicationsComponent } from './job-applications/job-applications.component';

@NgModule({
  declarations: [
    UserDetailsComponent,
    UsersComponent,
    DeleteRequestsComponent,
    TestAnalyticsComponent,
    DetailsAnswerSheetComponent,
    SupportDetailsComponent,
    JobApplicationsComponent,
  ],
  imports: [CommonModule, UserRoutingModule, SharedModule],
})
export class UserModule { }
